// extracted by mini-css-extract-plugin
export default {"splashScreen":"styles_splashScreen__gMffD","loadingDot":"styles_loadingDot__idC-9","run":"styles_run__24M65","logo":"styles_logo__aM-UB"};